<tui-theme-night *ngIf="dark$ | async" />
<tui-root [tuiMode]="(dark$ | async) ? 'onDark' : null">
  <router-outlet />
</tui-root>
